import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=036ef0b8&scoped=true"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=036ef0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ef0b8",
  null
  
)

export default component.exports